import React, { useState } from 'react';
import './ConsentScreen.css';

/* eslint-disable */

interface ConsentScreenProps {
	isOpen: boolean;
	onClose: () => void;
}

interface CookieCategory {
	id: string;
	title: string;
	description: string;
	enabled: boolean;
	required: boolean;
	hasViewCookies: boolean;
}

const ConsentScreen: React.FC<ConsentScreenProps> = ({ isOpen, onClose }) => {
	const [cookiePreferences, setCookiePreferences] = useState<CookieCategory[]>([
		{
			id: 'essential',
			title: 'Essential',
			description:
				'Required to enable basic website functionality. You may not disable essential cookies.',
			enabled: true,
			required: true,
			hasViewCookies: false
		},
		{
			id: 'targeted-advertising',
			title: 'Targeted Advertising',
			description:
				"Used to deliver advertising that is more relevant to you and your interests. May also be used to limit the number of times you see an advertisement and measure the effectiveness of advertising campaigns. Advertising networks usually place them with the website operator's permission.",
			enabled: true,
			required: false,
			hasViewCookies: true
		},
		{
			id: 'personalization',
			title: 'Personalization',
			description:
				'Allow the website to remember choices you make (such as your username, language, or the region you are in) and provide enhanced, more personal features. For example, a website may provide you with local weather reports or traffic news by storing data about your general location.',
			enabled: true,
			required: false,
			hasViewCookies: true
		},
		{
			id: 'analytics',
			title: 'Analytics',
			description:
				'Help the website operator understand how its website performs, how visitors interact with the site, and whether there may be technical issues.',
			enabled: true,
			required: false,
			hasViewCookies: true
		}
	]);

	const handleToggleChange = (id: string) => {
		setCookiePreferences((prev) =>
			prev.map((category) =>
				category.id === id && !category.required
					? { ...category, enabled: !category.enabled }
					: category
			)
		);
	};

	const handleViewCookies = (id: string) => {
		// This would typically open a modal or navigate to a detailed cookie list
		// eslint-disable-next-line no-console
		console.log(`View cookies for ${id}`);
	};

	return (
		<>
			{isOpen && (
				<div className="consent-overlay" onClick={onClose}>
					<div className="consent-screen" onClick={(e) => e.stopPropagation()}>
						<div className="consent-header">
							<h2 className="consent-title">Storage Preferences</h2>
							<button
								type="button"
								className="consent-close"
								onClick={onClose}
								aria-label="Close consent screen"
							>
								✕
							</button>
						</div>

						<div className="consent-intro">
							<p>
								When you visit websites, they may store or retrieve data about
								you using cookies and similar technologies
								(&quot;cookies&quot;). Cookies may be necessary for the basic
								functionality of the website as well as other purposes. You have
								the option of disabling certain types of cookies, though doing
								so may impact your experience on the website.
							</p>
						</div>

						<div className="cookie-categories">
							{cookiePreferences.map((category) => (
								<div key={category.id} className="cookie-category">
									<div className="category-content">
										<div className="category-info">
											<h3 className="category-title">{category.title}</h3>
											<p className="category-description">
												{category.description}
											</p>
											{category.hasViewCookies && (
												<button
													type="button"
													className="view-cookies-link"
													onClick={() => handleViewCookies(category.id)}
												>
													View Cookies
												</button>
											)}
										</div>
										<div className="category-toggle">
											<label
												className="toggle-switch"
												htmlFor={`toggle-${category.id}`}
											>
												<input
													id={`toggle-${category.id}`}
													type="checkbox"
													checked={category.enabled}
													onChange={() => handleToggleChange(category.id)}
													disabled={category.required}
												/>
												<span className="toggle-slider" />
											</label>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default ConsentScreen;
